<template>
  <el-card shadow="false" :header="header">
    <!-- 添加按钮 -->
    <div  v-if="showButton" class="button-container">
      <el-button type="primary" @click="handleButtonClick">
        Save to Financial Report
      </el-button>
    </div>
    <div class="table-wrapper">
      <div class="item" v-for="(item, index) in tableModel" :key="index">
        <div class="left">{{ item.label }}</div>
        <div class="right">{{ tableData[item.key] }}</div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: '',
    },
    tableModel: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Object,
      default: () => {},
    },
    showButton: {
      type: Boolean,
      default: false, // 默认不显示按钮
    },
  },
  methods: {
    handleButtonClick() {
      this.$emit('button-click')
    },
  },
}
</script>

<style scoped lang="scss">
/* 父组件样式 */
.financial-section {
  position: relative; /* 设置相对定位容器 */
}
.button-container {
  position: absolute;
  top: 10px;
  right: 10px;
}
.table-wrapper {
  width: 100%;
  border: 1px solid #e6e9f4;
  border-bottom: none;
  .item {
    display: flex;
    border-bottom: 1px solid #e6e9f4;
    padding: 0 16px;

    .left,
    .right {
      width: 50%;
      line-height: 32px;
      font-size: 14px;
    }
  }
}
</style>
